import React from "react";
import { Database, CloudRain, BrainCircuit, ShieldCheck } from "lucide-react";

const projects = [
  {
    title: "Social Media ETL Pipeline",
    icon: <Database size={18} />,
    description:
      "Built an ETL pipeline to extract data from Reddit and Twitter APIs using OAuth2, transform datasets into a star schema, and load structured data into MySQL for analysis.",
    tech: ["Python", "Pandas", "Requests", "MySQL"],
    accent: "border-l-4 border-gray-700",
    repo: "https://github.com/tripathisatwik/SocialMediaETL",
  },
  {
    title: "Weather Data Pipeline",
    icon: <CloudRain size={18} />,
    description:
      "Automated ingestion of weather data from JSON sources, converted to CSV, and loaded into PostgreSQL. Scheduled workflows using Apache Airflow and visualized analytics with Metabase dashboards.",
    tech: ["Python", "Airflow", "PostgreSQL", "Metabase"],
    accent: "border-l-4 border-gray-600",
    repo: "https://github.com/tripathisatwik/WeatherDataPipeline",
  },
  {
    title: "Machine Learning Pipelines",
    icon: <BrainCircuit size={18} />,
    description:
      "Developed structured ML workflows for predictive modeling using datasets like California Housing and Titanic Survival, focusing on preprocessing, feature engineering, and evaluation.",
    tech: ["Python", "Scikit-learn", "Pandas"],
    accent: "border-l-4 border-gray-500",
    repo: "https://github.com/tripathisatwik/MachineLearningPipelines",
  },
  {
    title: "CipherBox – Digital File Encryption System",
    icon: <ShieldCheck size={18} />,
    description:
      "Designed a secure file encryption web application using AES-128 encryption with password-based key derivation and email-based two-factor authentication (2FA) integrated with MySQL.",
    tech: ["Java", "AES-128", "MySQL", "Email OTP"],
    accent: "border-l-4 border-gray-400",
    repo: "https://github.com/tripathisatwik/CipherBox",
  },
];

const Projects = () => {
  return (
    <section
      id="projects"
      className="py-16 px-6 bg-white dark:bg-gray-950"
    >
      <div className="max-w-6xl mx-auto">
        {/* Title */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-semibold text-gray-800 dark:text-gray-100">
            Selected Projects
          </h2>
          <p className="mt-3 text-gray-500 dark:text-gray-400 max-w-2xl mx-auto">
            Real-world data engineering and analytics projects demonstrating pipeline design, automation, and system reliability.
          </p>
        </div>

        {/* Project Grid */}
        <div className="grid gap-6 md:grid-cols-2">
          {projects.map((project, index) => (
            <div
              key={index}
              onClick={() => window.open(project.repo, "_blank")}
              role="button"
              title="Open project repository"
              className={`cursor-pointer bg-gray-50 dark:bg-gray-900 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-800 p-6 transition-all duration-200 hover:-translate-y-1 hover:shadow-md hover:border-gray-400 ${project.accent}`}
            >
              {/* Header */}
              <div className="flex items-center gap-3 mb-4">
                <span className="p-2 rounded-lg bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-200">
                  {project.icon}
                </span>
                <h3 className="text-lg font-medium text-gray-800 dark:text-gray-100">
                  {project.title}
                </h3>
              </div>

              {/* Description */}
              <p className="text-sm text-gray-600 dark:text-gray-400 mb-4 leading-relaxed">
                {project.description}
              </p>

              {/* Tech Stack */}
              <div className="flex flex-wrap gap-2 mb-5">
                {project.tech.map((t, i) => (
                  <span
                    key={i}
                    className="px-3 py-1 text-xs rounded-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-300"
                  >
                    {t}
                  </span>
                ))}
              </div>

              </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
